import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { loginActions } from './action/loginAction';
import { withTranslation } from 'react-i18next';
import { alertActions } from './action/AlertAction';
import Header from './Header/Header';
import { Helmet } from "react-helmet";
import AllCountries from './Pages/Home/Nationality.json';
import Footer from './Footer/Footer';
// const countryLst = [{ id: 0, name: "Select Nationality" }, { id: 1, name: "India" }, { id: 2, name: "UAE" }, { id: 3, name: "Ban" }, { id: 4, name: "Philippines" }]
// const countryLst = [{ id: 0, name: "Select Nationality" }, { id: 1, name: "India" }, { id: 2, name: "UAE" }, { id: 3, name: "Qatar" }, { id: 4, name: "Oman" }]
const countryLst = AllCountries.Nationality;  // 177 Countries Loaded 
class RegisterActivation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            regEmail: '',
            regNationality: 0,
            ErrorPicNation: "",
            ErrorEnterEmail: ""
        }
        this.btnActivation = this.btnActivation.bind(this);
    }
    handleTextChange(e) {
        try {
            this.setEmptyError()
            let value = e.target.value
            if (e.target.name == "regNationality") {
                const regex = /^[0-9]*$/;
                if (!regex.test(value) && !value == '') { return; }
            }
            this.setState({ [e.target.name]: value });
        } catch (ex) { }
    }

    // btnActivation(e) {
    //     e.preventDefault();
    //     if (this.state.regEmail && this.state.regEmail.trim() != "") {
    //         if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(this.state.regEmail)) {
    //             if (this.state.regNationality > 0) {
    //                 let nationname = countryLst.filter(Fobj => Fobj.id == this.state.regNationality)[0].name
    //                 this.props.RegisterActivate(this.props.otp.mobileNo, this.state.regEmail, parseInt(this.state.regNationality), this.props.i18n.language, "", this.props.otp.Ccode, nationname);
    //             } else { this.showMsg('lblNation'); }
    //         } else { this.showMsg('lblEnterValidEmail'); }
    //     } else { this.showMsg('lblenterEmail'); }
    // }

    btnActivation(e) {
        e.preventDefault();
        const { regEmail, regNationality } = this.state;
        const { otp, i18n } = this.props;
        let validationfalg = true
        // Email presence check
        if (!regEmail || regEmail.trim() === "") {
            this.showMsg('lblenterEmail', 1);
            validationfalg = false;
        }
        // Email format check
        const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
        if (!emailRegex.test(regEmail) && validationfalg == true) {
            this.showMsg('lblEnterValidEmail', 1);
            validationfalg = false;
        }
        // Nationality check
        if (!(regNationality > 0)) {
            this.showMsg('lblNation', 2);
            validationfalg = false;
        }
        if (validationfalg) {
            // Get nation name
            const nationObj = countryLst.find(obj => obj.id === regNationality);
            const nationName = nationObj ? nationObj.name : "";
            // Proceed with activation
            this.props.RegisterActivate(
                otp.mobileNo,
                regEmail,
                parseInt(regNationality),
                i18n.language,
                "",
                otp.Ccode,
                nationName
            );
        }
    }


    showMsg = (msg, flagNo) => {
        let errorstring = this.props.t(msg)
        if (flagNo > 0) {
            this.setErrorMessage(flagNo, errorstring)
        }
        else {
            this.props.alertError(errorstring);
        }
    }

    setEmptyError = () => {
        this.setState({ ErrorEnterEmail: "" })
        this.setState({ ErrorPicNation: "" })
    }

    setErrorMessage = (flagNo, errorstring) => {
        switch (flagNo) {
            case 1:
                this.setState({ ErrorEnterEmail: errorstring })
                break;
            case 2:
                this.setState({ ErrorPicNation: errorstring })
                break;
            default:
                break;
        }
    }

    setSelected = (val) => {
        this.setState({ regNationality: val });
    }
    render() {
        const { t } = this.props;
        let ErrorEmail = this.state.ErrorEnterEmail.length > 0;
        let ErrorNational = this.state.ErrorPicNation.length > 0;
        return (
            <>
                {process.env.REACT_APP_MODE != "development" && <Helmet>
                    <title>Gulf Ticket - Register Activation</title>
                    <meta name="description" content="Securely Access Your Gulf Ticket Account: Register Now" />
                    <meta name="keywords" content="Gulf Ticket, online raffle draw, Biggest Online Draw" />

                    <meta property="og:title" content="Gulf Ticket - Register Activation" />
                    <meta property="og:site_name" content="Gulf Ticket" />
                    <meta property="og:url" content="https://gulfticket.com" />
                    <meta property="og:description" content="Securely Access Your Gulf Ticket Account: Register Now" />
                    <meta property="og:type" content="website" />
                    <meta property="og:image" content="https://gulfticket.com/assets/img/logo.png" />
                </Helmet>}
                <Header />

                <div className="subContainer">
                    <div className="register">
                        <div className="registerInr">
                            <h1>{t('lblSignActive')}</h1>
                            {/* <div className="logRegTitle"><img src="./assets/img/icons/register.webp" alt='Register Activation Icon' /><h2>{t('lblSignActive')}</h2></div> */}
                            <form class="register-form margin-top-20" onSubmit={this.btnActivation}>
                                <div class="formCont">
                                    <label>{`${t('lblEmail')}`}<sup>*</sup></label>
                                    <input className={`${ErrorEmail ? "errorBorder" : ""}`} type="text" placeholder={`${t('lblEmail')}*`} name='regEmail' value={this.state.regEmail} onChange={this.handleTextChange.bind(this)} maxLength={50} autocomplete="off" />
                                    {ErrorEmail && <div class="errorTxt">{this.state.ErrorEnterEmail}</div>}
                                </div>
                                <div class="formCont">
                                    <label>{t('lblselnation')}<sup>*</sup></label>
                                    <div className="nationality">
                                        <select className={`nationalityDropDown ${ErrorNational ? "errorBorder" : ""}`} onChange={(e) => { this.setSelected(e.target.value); this.setEmptyError() }} defaultValue={this.state.regNationality}>
                                            {countryLst && countryLst.map((obj, inx) => (
                                                <option key={`q_${inx}`} value={obj.id}>
                                                    {obj.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    {ErrorNational && <div class="errorTxt">{this.state.ErrorPicNation}</div>}
                                </div>
                                <div class="formCont">
                                    <button type='submit' >{t('lblSubmit')}</button>
                                </div>
                            </form>
                        </div>
                    </div >
                </div >
                <Footer />
            </>
        );
    }
}
function mapStateToProps(state) {
    const { user, otp } = state.loginReducer;
    return { user, otp };
}
const mapActionToProps = {
    RegisterActivate: loginActions.RegisterActivate,
    alertError: alertActions.error,
    //alertsucc: alertActions.success
}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(RegisterActivation))